import Api from 'App/api'

export const getCompanyLinks = Api.get({
  controller: 'company_links',
  action: 'list',
})

export const getHtml = Api.get({
  controller: 'company_links',
  action: 'getHtml',
})

export const submit = Api.post({
  controller: 'company_links',
  action: 'submit',
})
